import Big from "big.js";

type DecimalValue = number | string;

type Operand = "plus" | "minus" | "times" | "div";

const getFormattedDecimalValue = (
  firstValue: DecimalValue,
  secondValue: DecimalValue,
  operand: Operand,
): number => {
  const big = new Big(firstValue)[operand](secondValue);
  const amount = big.toNumber();

  return amount;
};

export default getFormattedDecimalValue;
